export default __webpack_public_path__ + "static/media/019-german flag.038e2729.svg";